module.exports = __webpack_public_path__ + "img/t4-b1.3664e466.png";